import React, { useEffect, useState } from 'react';
import { Box, Typography, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import useMediaQuery from '@mui/material/useMediaQuery';
import UsersWithoutGroupPanel from '../components/validateActions/UsersWithoutGroupPanel';
import AllUnvalidatedActionsPanel from '../components/validateActions/AllUnvalidatedActionsPanel';
import FlaggedImagesPanel from '../components/validateActions/FlaggedImagesPanel';
import MyGroupsPanel from '../components/validateActions/MyGroupsPanel';
import { useLanguageContext } from '../components/contexts/LanguageContext';
import useTranslation from '../components/customHooks/translations';
import { useUserInfoContext } from '../hooks/use-user-info-context';

export const actionsTabKeys = [
  'myGroups',
  'validateActionsUsersWithoutGroupsTab',
  'validateActionsAllUnvalidatedActionsTab',
  'validateActionsFlaggedImagesTab',
];

const tabPanelContent = (user) => ({
  myGroups: <MyGroupsPanel user={user} />,
  validateActionsUsersWithoutGroupsTab: <UsersWithoutGroupPanel user={user} />,
  validateActionsAllUnvalidatedActionsTab: (
    <AllUnvalidatedActionsPanel user={user} />
  ),
  validateActionsFlaggedImagesTab: <FlaggedImagesPanel />,
});

const ValidateActions = () => {
  const { user, userType } = useUserInfoContext();
  const translation = useTranslation();
  const [selectedTab, setSelectedTab] = useState(actionsTabKeys[0]);
  const scrollableTabs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { language } = useLanguageContext();
  // Admins see every queue; teachers review their groups and handle
  // unsafe-flagged images.
  const visibleTabKeys =
    userType === 'Admin'
      ? actionsTabKeys
      : ['myGroups', 'validateActionsFlaggedImagesTab'];

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    setSelectedTab(actionsTabKeys[0]);
  }, [language]);

  return (
    <>
      <Box sx={{ textAlign: { xs: 'center' } }}>
        <Typography variant="h1" sx={{ mt: { xs: '1.5em', md: '0' } }}>
          {translation.validateActions}
        </Typography>
      </Box>
      {/* render tab view for Admins and Teachers, render single page search bar view for group owners */}
      {userType &&
        (userType === 'Admin' || userType === 'Teacher' ? (
          <TabContext
            value={
              visibleTabKeys.indexOf(selectedTab) !== -1
                ? selectedTab
                : visibleTabKeys[0]
            }
          >
            <Box
              sx={{
                mt: '4em',
                display: { xs: 'flex', sm: 'block' },
                justifyContent: 'center',
                borderBottom: 1,
                borderTop: 1,
                borderColor: 'divider',
                maxWidth: { xs: 320, sm: '100%' },
              }}
            >
              <TabList
                onChange={handleTabChange}
                aria-label="admin dashboard tabs"
                scrollButtons
                allowScrollButtonsMobile
                variant={scrollableTabs ? 'scrollable' : 'fullWidth'}
                centered={!scrollableTabs}
              >
                {visibleTabKeys.map((tabKey) => (
                  <Tab
                    key={tabKey}
                    label={translation[tabKey]}
                    value={tabKey}
                  />
                ))}
              </TabList>
            </Box>
            {visibleTabKeys.map((tabKey) => (
              <TabPanel key={tabKey} value={tabKey}>
                {tabPanelContent(user)[tabKey]}
              </TabPanel>
            ))}
          </TabContext>
        ) : (
          <MyGroupsPanel user={user} />
        ))}
    </>
  );
};

export default ValidateActions;
